module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    attrs: {
      "data-background-color": _vm.backgroundColor,
      "data-active-color": _vm.activeColor
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper",
    attrs: {
      "id": "style-3"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('ul', {
    class: _vm.navClasses,
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.sidebarLinks), function(link, index) {
    return (_vm.amountAccessUrlPermission(link.path)) ? _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('i', {
      class: link.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(link.name))])])])])]) : _vm._e()
  }), 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "alt": ""
    }
  })]), _vm._v("\n                Pit Format Statistics "), _c('sup', [_vm._v("BETA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9a0745ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/SideBar.vue
// module id = 448
// module chunks = 1